export const serviceOptions = [
  {
    value: "vitrage",
    label: "Vitrage / Vitrines",
    requiresDimensions: true,
    options: ["anti-effraction", "feuillete", "double-vitrage"],
  },
  {
    value: "rideau",
    label: "Rideau métallique",
    requiresDimensions: true,
    options: ["motorisation", "lames-anti-effraction"],
  },
  {
    value: "porte",
    label: "Porte",
    requiresDimensions: true,
    options: ["blindage", "anti-effraction"],
  },
  {
    value: "alarme",
    label: "Alarme / Caméra",
    requiresDimensions: false,
    options: ["pack-camera", "pack-alarme"],
  },
  {
    value: "menuiserie",
    label: "Menuiserie alu",
    requiresDimensions: true,
    options: ["isolation", "couleurs"],
  },
  {
    value: "metallerie",
    label: "Métallerie",
    requiresDimensions: false,
    options: ["soudure-sur-mesure"],
  },
  {
    value: "automatisme",
    label: "Automatisme",
    requiresDimensions: false,
    options: ["motorisation", "telecommande"],
  },
];

export const optionLabels = {
  "anti-effraction": "Anti-effraction",
  feuillete: "Vitrage feuilleté",
  "double-vitrage": "Double vitrage",
  motorisation: "Motorisation",
  "lames-anti-effraction": "Lames renforcées",
  blindage: "Blindage",
  "pack-camera": "Pack caméras",
  "pack-alarme": "Pack alarme",
  isolation: "Isolation renforcée",
  couleurs: "Couleurs spéciales",
  "soudure-sur-mesure": "Soudure sur-mesure",
  telecommande: "Télécommandes",
};

export const pricingRules = {
  vitrage: {
    base: { depannage: 180, remplacement: 320, installation: 450 },
    perM2: 160,
    options: { "anti-effraction": 120, feuillete: 90, "double-vitrage": 140 },
  },
  rideau: {
    base: { depannage: 220, remplacement: 420, installation: 650 },
    perM2: 110,
    options: { motorisation: 280, "lames-anti-effraction": 150 },
  },
  porte: {
    base: { depannage: 190, remplacement: 380, installation: 520 },
    perM2: 140,
    options: { blindage: 240, "anti-effraction": 140 },
  },
  alarme: {
    base: { depannage: 150, remplacement: 350, installation: 600 },
    perM2: 0,
    options: { "pack-camera": 320, "pack-alarme": 260 },
  },
  menuiserie: {
    base: { depannage: 210, remplacement: 420, installation: 650 },
    perM2: 180,
    options: { isolation: 160, couleurs: 90 },
  },
  metallerie: {
    base: { depannage: 240, remplacement: 480, installation: 700 },
    perM2: 0,
    options: { "soudure-sur-mesure": 200 },
  },
  automatisme: {
    base: { depannage: 180, remplacement: 360, installation: 620 },
    perM2: 0,
    options: { motorisation: 300, telecommande: 80 },
  },
};
